import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {ZIDXAccountListView} from "../../AccountListView.js";

export class ZIDXAccountBillingHistory implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountBillingHistoryContainer";
    }
    render(){
        // console.log("billing history");
        let listView=new ZIDXAccountListView();
        listView.render();
    }
}